/**
 * Higher-order component that wraps a component with ConsentGuard.
 *
 * @example
 * ```tsx
 * const ProtectedDashboard = withConsentGuard(DashboardPage)
 * ```
 */

import { ConsentGuard } from './ConsentGuard'

export function withConsentGuard<P extends object>(Component: React.ComponentType<P>) {
  return function WrappedComponent(props: P) {
    return (
      <ConsentGuard>
        <Component {...props} />
      </ConsentGuard>
    )
  }
}
